import usePermissions from "../../../hooks/usePermissions";
import { Pencil } from "lucide-react";
import { Button } from "./Button";

const { forwardRef } = require("react");

const UpdateButtonTrigger = forwardRef((props, ref) => {
  const permissions = usePermissions();
  const hasEditPermissions = permissions.canEdit();

  return (
    hasEditPermissions && (
      <Button {...props} variant="ghost" size="icon" ref={ref}>
        <Pencil className="w-4 h-4" />
      </Button>
    )
  );
});

export default UpdateButtonTrigger;
